module.exports = __webpack_public_path__ + "static/img/hall_5.067d083.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/hall_5.jpg
// module id = di9r
// module chunks = 3